import { languages } from "../Language/Language";

export function getDefaultLanguage() {
  const { pathname } = window.location;

  const part = pathname.split("/")[1];

  return part in languages ? part : "en-gb";
}
